<h2 mat-dialog-title>Dados do atendimento</h2>

<mat-dialog-content class="mat-typography">
  <div *ngIf="encounter" class="encounters">
    <div *ngIf="encounter.byOrderInfo.isByOrder == false">
      <div><b> {{ encounter.type }}:</b> {{ encounter.name ? encounter.name : 'Atendimento' }} </div>
      <div><b> Instituição:</b> {{ organization.name }} </div>
      <div><b> Especialista:</b> {{ encounter.practitioner.name }} </div>
      <div><b> Data e Hora:</b> {{ layout.dateTimeFormat(encounter.startDate) }}</div>
    </div>
    <div *ngIf="encounter.byOrderInfo.isByOrder == true">
      <div><b> {{ encounter.type }}:</b> {{ encounter.name ? encounter.name : 'Atendimento' }} </div>
      <div><b> Instituição:</b> {{ organization.name }} </div>
      <div><b> Especialista:</b> {{ encounter.practitioner.name }} </div>
      <div><b> Data e Hora:</b> Atendimento por ordem de chegada a partir de {{
        encounter.byOrderInfo.startServiceHour | date:'dd \'de\' MMMM \'às\' HH:mm'  }}</div> 
    </div>
  </div>

  <mat-tab-group>
    <mat-tab label="Observação">
      <div class="observation-container">
        <p class="observation-label">Observação:</p>
        <textarea readonly class="observation-textarea" matInput rows="5" [(ngModel)]="encounter.diagnosis" placeholder="..."></textarea>
      </div>
    </mat-tab>

    <mat-tab label="Medicamentos receitados">
      <mat-card style="margin-top: 4px" *ngFor="let prescription of prescriptions">
        <div class="medicationInfo">
          <div *ngIf="prescription.medicationName"><b>Nome da medicação:</b> {{ prescription.medicationName }}</div>
          <div *ngIf="prescription.medicationType"><b>Tipo da medicação:</b> {{ prescription.medicationType }}</div>
          <div *ngIf="prescription.dosage"><b>Dosagem:</b> {{ prescription.dosage }}</div>
          <div *ngIf="prescription.use"><b>Uso:</b> {{ prescription.use }}</div>
          <div *ngIf="prescription.recommendation"><b>Recomendação:</b> {{ prescription.recommendation }}</div>
        </div>
      </mat-card>
    </mat-tab>
  </mat-tab-group>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button color="primary" [mat-dialog-close]="false">Fechar</button>
</mat-dialog-actions>
